<template>
  <a-spin :spinning="loading">
    <div>
      <!-- 选择项目 -->
      <CombatChoice @combatChecked="combatChecked"/>
      <!-- 选择参赛球队 -->
      <Team ref="team" @teamChecked="teamChecked" :choiceTeamId="checkedTeams" :needHidden="false"/>
      <!-- 选择球队秋衣颜色 -->
      <ShirtColor ref="shirtColor" :teamId="choiceTeamId"/>
      <!-- 选择教练领队 -->
      <StaffList ref="staffList"/>
      <EnclosureTeam ref="enclosureTeam" :enclosureTeam="enclosureTeam" @enclosureTeamSuccess="enclosureTeamSuccess"/>
      <!-- 选择参赛球员 -->
      <Player ref="player" :teamId="choiceTeamId" :combat="curCombat"/>
      <AddEnclosure ref="addEnclosure" @jump="jump" @enclosureSuccess="enclosureSuccess"></AddEnclosure>
    </div>
  </a-spin>
</template>
<script>
import CombatChoice from './CombatChoice'
import EnclosureTeam from './EnclosureTeam'
import Team from '../team/Team'
import ShirtColor from './ShirtColor'
import StaffList from '@comm/components/join/staff/StaffList'
import Player from './Player'
import AddEnclosure from '../enclosure/AddEnclosure'
export default {
  components: {
    CombatChoice,
    Team,
    ShirtColor,
    StaffList,
    Player,
    AddEnclosure,
    EnclosureTeam
  },
  data () {
    return {
      loading: false,
      matchId: this.$route.query.matchId,
      programId: this.$route.query.programId,
      agencyId: this.$route.query.agencyId || null,
      step: Number(this.$route.query.step || 2),
      choiceTeamId: null,
      checkedTeams: [],
      enclosureTeam: {},
      curCombat: null
    }
  },
  methods: {
    teamChecked (teamId) {
      if (teamId === null) {
        this.choiceTeamId = null
        if (this.curCombat === null) {
          this.$router.push({query: {matchId: this.matchId, programId: this.programId, step: this.step, agencyId: this.agencyId}})
        } else {
          this.$router.push({query: {matchId: this.matchId, programId: this.programId, step: this.step, agencyId: this.agencyId, combatDetailId: this.curCombat.combatDetailId}})
        }
        return
      }
      if (this.curCombat === null) {
        this.$message.error('请先选择参赛组别，再选择参数队伍')
        localStorage.removeItem('teamId')
        this.$refs.team.resetChoicedTeam()
        this.$router.push({query: {matchId: this.matchId, programId: this.programId, step: this.step, agencyId: this.agencyId}})
      } else {
        this.choiceTeamId = teamId
        this.$router.push({query: {matchId: this.matchId, programId: this.programId, step: this.step, agencyId: this.agencyId, teamId: teamId, combatDetailId: this.curCombat.combatDetailId}})
      }
      this.findEnclosureTeamList(teamId)
    },
    findEnclosureTeamList (teamId) {
      this.$api.join.findEnclosureTeamList({matchId: this.$route.query.matchId, teamId: teamId}).then(res => {
        if (res.status === 0) {
          if (res.data.enclosure != null) {
            this.enclosureTeam = JSON.parse(res.data.enclosure)
          }
        }
      })
    },
    combatChecked (combat) {
      // this.$refs.team.resetChoicedTeam()
      this.$refs.shirtColor.resetColor()
      this.curCombat = combat
      if (this.choiceTeamId !== null) {
        this.$router.push({query: {matchId: this.matchId, programId: this.programId, step: this.step, agencyId: this.agencyId, teamId: this.choiceTeamId, combatDetailId: this.curCombat.combatDetailId}})
      } else {
        this.$router.push({query: {matchId: this.matchId, programId: this.programId, step: this.step, agencyId: this.agencyId, combatDetailId: this.curCombat.combatDetailId}})
      }
    },
    signUp () {
      if (this.curCombat == null) {
        this.$message.error('请选择参赛组别')
        return
      }
      if (this.choiceTeamId == null) {
        this.$message.error('请选择参赛队伍')
        return
      }
      let staffData = this.$refs.staffList.getChoiceCoach()
      if (!staffData.result) {
        this.$message.error(staffData.content)
        return
      }
      let choicedPlayers = this.$refs.player.getChoicedPlayes()
      if (choicedPlayers.length === 0) {
        this.$message.error('请选择参赛队员')
        return
      }
      let checkEnclosureTeam = this.$refs.enclosureTeam.checkEnclosureTeam()
      if (!checkEnclosureTeam) {
        return
      }
      let players = []
      let playerJerseyNumbers = []
      choicedPlayers.forEach(p => {
        playerJerseyNumbers.push(p.jerseyNumber)
        players.push({
          cardId: p.cardId,
          sex: p.sex,
          name: p.name,
          type: p.type,
          jerseyNumber: p.jerseyNumber
        })
      })
      let playerJerseyNumbersDis = Array.from(new Set(playerJerseyNumbers))
      if (choicedPlayers.length != playerJerseyNumbersDis.length) {
        this.$message.error('选中的参赛队员中有重复的球衣号码')
        return
      }
      let shirtColor = this.$refs.shirtColor.getShirtColor()
      let params = {
        matchId: this.$route.query.matchId,
        teamId: this.choiceTeamId,
        teamNumber: 1,
        agencyId: this.$route.query.agencyId,
        combatId: this.curCombat.combatId,
        combatDetailId: this.curCombat.combatDetailId,
        customerId: JSON.parse(localStorage.getItem('userInfo')).id,
        homeTeamJerseyColor: shirtColor.homeColor,
        visitingTeamJerseyColor: shirtColor.visitColor,
        joinLeaderStaffs: staffData.leaderIds || -1,
        enclosureTeam: this.enclosureTeam,
        players: players
      }
      if (this.programId === 4) {
        params['homeGoalkeeperJerseyColor'] = shirtColor.homeKeeperColor
        params['visitingGoalkeeperJerseyColor'] = shirtColor.visitKeeperColor
      }
      this.checkEnclosureBigball(params)
    },
    checkEnclosureBigball (params) {
      this.loading = true
      this.$api.join.checkEnclosureBigball(params).then(res => {
        if (res.status === 0) {
          let players = res.data.players
          if (players.length > 0) {
            this.$refs.addEnclosure.show(res.data, params)
          } else {
            this.enclosureSuccess(params)
          }
        }
      }).finally(() => {
        this.loading = false
      })
    },
    // 篮球报名
    joinBaskeyball (params) {
      this.loading = true
      this.$api.join.joinBaskeyball(params).then(res => {
        if (res.status === 0) {
          this.handlerSuccess('报名成功')
        } else {
          this.handlerError(res.msg)
        }
      }).catch(err => {
        console.log('err', err)
        this.handlerError('报名失败')
      }).finally(_ => {
        this.loading = false
      })
    },
    // 足球报名
    joinFootball (params) {
      this.loading = true
      this.$api.join.joinFootball(params).then(res => {
        if (res.status === 0) {
          this.handlerSuccess('报名成功')
        } else {
          this.handlerError(res.msg)
        }
      }).catch(err => {
        console.log('err', err)
        this.handlerError('报名失败')
      }).finally(_ => {
        this.loading = false
      })
    },
    handlerSuccess (res) {
      this.$message.success(res)
      this.$emit('signupSuccess')
    },
    handlerError (err) {
      this.$message.error(err)
    },
    jump (joinData) {
      this.enclosureSuccess(joinData)
    },
    enclosureSuccess (joinData) {
      if (this.programId === 4) {
        this.joinFootball(joinData)
      } else {
        this.joinBaskeyball(joinData)
      }
    },
    enclosureTeamSuccess (enclosureTeam) {
      console.log(enclosureTeam)
      this.enclosureTeam = enclosureTeam
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/comm/components/join/bigBall/StepTwo.vue